import { Directive } from '@angular/core';

@Directive({
  selector: '[atLabel]'
})
export class AtLabel {

  constructor() { }

}
